
import { useState } from "react";
import Sidebar from "./Sidebar";
import BasicDetails from "./BasicInfoStep";
import AddressDetails from "./AddressStep";
import KycDetails from "./KycStep";
import { FormProvider } from "./FormContext";

const Onboarding = () => {
  const [step, setStep] = useState(1);

  return (
    <div
      className="w-[800px] h-[560px] flex justify-center items-center bg-gray-100 shadow-lg rounded-lg"
    >
      <div className="w-full h-full flex bg-white-1 rounded-lg shadow-lg overflow-hidden max-w-4xl">
        <Sidebar step={step} />
        <FormProvider>
          <div className="w-[600px] h-full flex items-center justify-center  p-6">
            {step === 1 && <BasicDetails onNext={() => setStep(2)} />}
            {step === 2 && (
              <AddressDetails
                onNext={() => setStep(3)}
                onBack={() => setStep(1)}
              />
            )}
            {step === 3 && <KycDetails onBack={() => setStep(2)} />}
          </div>
        </FormProvider>
      </div>
    </div>
  );
};

export default Onboarding;
